import { useCallback, useEffect, useRef, useState } from 'react'

// Kopiert Text und merkt sich kurz, dass es geklappt hat, für Icon-Swap oder
// Label „Kopiert“. copy() gibt false zurück, wenn der Browser das Schreiben
// verweigert (kein sicherer Kontext, fehlende Berechtigung). Den Fehler-Toast
// zeigt der Aufrufer.
export const useCopyToClipboard = ({ resetAfter = 2000 } = {}) => {
  const [copied, setCopied] = useState(false)
  const timeout = useRef(null)

  useEffect(() => () => clearTimeout(timeout.current), [])

  const copy = useCallback(
    async (text) => {
      clearTimeout(timeout.current)

      try {
        await navigator.clipboard.writeText(String(text))
      } catch (err) {
        setCopied(false)
        return false
      }

      setCopied(true)
      timeout.current = setTimeout(() => setCopied(false), resetAfter)

      return true
    },
    [resetAfter]
  )

  return { copied, copy }
}
